import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CreditCard, Lock, Smartphone } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-16 md:py-24 px-4 bg-brand-dark relative overflow-hidden text-white" data-id="element-144">
      <div className="absolute inset-0 bg-radial-green opacity-40" data-id="element-145" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-146">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-black mb-6 leading-tight" data-id="element-147">
          Dentro de un mes seguirás teniendo dos opciones...
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto space-y-4" data-id="element-148">
          <p data-id="element-149">Seguir buscando respuestas en distintos lugares.</p>
          <p data-id="element-150">O tener toda la información organizada en un solo sitio.</p>
          <p className="font-bold text-brand-light text-2xl pt-4" data-id="element-151">
            La decisión es tuya.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="max-w-md mx-auto" data-id="element-152">
          <CTAButton href="#pricing" data-id="element-153">🚀 QUIERO ACCEDER AHORA</CTAButton>

          <div className="flex justify-center items-center gap-4 mt-6 text-xs text-white/70 font-medium flex-wrap" data-id="element-154">
            <div className="flex items-center gap-1" data-id="element-155">
              <Lock className="w-4 h-4 text-brand-light" data-id="element-156" /> Compra Segura
            </div>
            <span className="text-white/30 hidden sm:inline" data-id="element-157">|</span>
            <div className="flex items-center gap-1" data-id="element-158">
              <Shield className="w-4 h-4 text-brand-light" data-id="element-159" /> Acceso Inmediato
            </div>
            <span className="text-white/30 hidden sm:inline" data-id="element-160">|</span>
            <div className="flex items-center gap-1" data-id="element-161">
              <Smartphone className="w-4 h-4 text-brand-light" data-id="element-162" /> Disponible
              24/7
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}